<template>
  <card class="user-card">
    <div class="user-info">
      <div class="user-icon">
        <el-avatar src="/static/img/user_placeholder.png"></el-avatar>
      </div>
      <div class="user-details">
        <div class="user-name">
          {{data.fullname}}
        </div>
        <div class="user-email">
          {{data.userid}}
        </div>
      </div>
    </div>
    <div class="collapse-header" @click="toggle">
      <span>More info</span>
      <span class="arrow" :class="{ rotated: isOpen }">⌄</span>
    </div>
    <div class="collapse-line"></div>

    <transition name="collapse">
      <div class="collapse-content" v-if="isOpen">
          <p class="space-items-togle"> <strong>{{ $t('sign_up_dt_txt')}}:</strong> {{data.reg_dt}}</p>
          <p class="space-items-togle"> <strong>{{ $t('currentbalance') }}:</strong> {{data.balance}}</p>
          <p class="space-items-togle"> <strong>{{ $t('number_of_accountstxt') }}:</strong> {{data.qtd_accounts}}</p>
          <p class="space-items-togle"> <strong>{{ $t('number_of_vps') }}:</strong> {{data.vms}}</p>
          <p class="space-items-togle"> <strong>{{ $t('last_login') }}:</strong> {{formatDate(data.last_login)}}</p>
          <p class="space-items-togle"> <strong>{{ $t('affiliatetxt') }}:</strong> {{data.affiliateUser}}</p>
      </div>
    </transition>
    <div class="space-items-action-btn" v-if="isOpen">
      <p-button type="default" wide v-on:click="openAction" >
        <i class="fa fa-gear"></i>
      </p-button>
    </div>
</card>
</template>

<script>
export default {
  name: 'BillingCollapseItem',
  props: {
    data: {},
  },
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    formatDate(date){
      return this.$moment.utc(date).format('YYYY-MM-DD (hh:mm:ss)')
    },
    toggle() {
      this.isOpen = !this.isOpen;
    },
    openAction() {
      //TODO:
    }
  },
};
</script>

<style scoped>
.user-card {
  width: 100%;
  max-width: 300px;
  padding: 5px;
  border-radius: 12px;
  font-family: sans-serif;
}

.user-info {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.user-icon {
  font-size: 32px;
  background-color: #eee;
  border-radius: 50%;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
}

.user-details {
  display: flex;
  flex-direction: column;
}

.user-name {
  font-weight: bold;
  font-size: 16px;
}

.user-email {
  font-size: 14px;
  color: #555;
}

.collapse-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  font-weight: 500;
  padding-bottom: 4px;
}

.collapse-line {
  height: 1px;
  background-color: #333;
  margin-bottom: 8px;
}

.arrow {
  display: inline-block;
  transition: transform 0.3s ease;
}

.arrow.rotated {
  transform: rotate(180deg);
}

.collapse-enter-active, .collapse-leave-active {
  transition: all 0.5s ease;
}
.collapse-enter-from, .collapse-leave-to {
  opacity: 0;
  transform: translateY(-5px);
}

.space-items-togle {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.space-items-action-btn {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>

<style scoped>
@media (max-width: 400px) {
  .user-card {
    padding: 12px;
  }
  .user-name {
    font-size: 14px;
  }
  .user-email {
    font-size: 12px;
  }
  .collapse-header {
    font-size: 14px;
  }
  .space-items-togle {
    font-size: 13px;
  }
}
</style>
